import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginScreen from "./screens/LoginScreen";
import CandidateScreen from "./screens/CandidateScreen";
import { Layout } from "antd";


//Component
const JobManager: React.FC = () => {
  return (
    <Routes>
      <Route path="/en" element={
        <Layout style={{ height: "100vh", width: "100vw" }}>
          <LoginScreen
            title="Are you ready to"
            subTitle="To take a look at?"
            description="Welcome to Career Swipe, where attraction and matching go hand in hand."
          />
        </Layout>
      } />

      <Route path="/fr"
        element={
          <Layout style={{ height: '100vh', width: '100vw' }}>
            <LoginScreen
              title='Êtes-vous prêt à'
              subTitle="Jeter un coup d'œil?"
              description="Bienvenue à Career Swipe, où attraction et matching vont de pair."
            />
          </Layout>
        }
      />

      <Route path="/en/candidate" element={
        <Layout style={{ height: "100vh", width: "100vw" }}>
          <CandidateScreen />
        </Layout>
      } />

      <Route path="/fr/candidate" element={
        <Layout style={{ height: "100vh", width: "100vw" }}>
          <CandidateScreen />
        </Layout>
      } />

      <Route
        path="/"
        element={<Navigate to="/en" replace />}
      />
    </Routes>
  );
};

export default JobManager;